import { HttpErrorResponse } from "@angular/common/http";

function normalizeMessage(value: unknown): string | null {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed || null;
  }

  if (Array.isArray(value)) {
    const joined = value
      .map((item) =>
        (() => {
          if (typeof item === "string") {
            return item.trim();
          }
          return "";
        })(),
      )
      .filter((item) => item.length > 0)
      .join("; ");
    return joined || null;
  }

  return null;
}

export function getBackendErrorMessage(error: unknown, fallback = "An unknown error occurred."): string {
  if (error instanceof HttpErrorResponse) {
    if (error.status === 0) {
      return "Unable to reach server.";
    }

    const responseMessage = normalizeMessage(error.error?.message);
    if (responseMessage) {
      return responseMessage;
    }

    const rawResponse = normalizeMessage(error.error);
    if (rawResponse) {
      return rawResponse;
    }

    const httpMessage = normalizeMessage(error.message);
    if (httpMessage) {
      return httpMessage;
    }
  }

  if (error instanceof Error) {
    const directMessage = normalizeMessage(error.message);
    if (directMessage) {
      return directMessage;
    }
  }

  const fallbackMessage = normalizeMessage(fallback);
  return fallbackMessage ?? "An unknown error occurred.";
}

export function createBackendError(error: unknown, fallback?: string): Error {
  return new Error(getBackendErrorMessage(error, fallback));
}
